const cashFlowMetricsCache = new Map<string, unknown>()

export const buildCashFlowMetricsCacheKey = (pageKey: string, dateStart: string, dateEnd: string) =>
  `${pageKey}:${dateStart}:${dateEnd}`

export const getCashFlowMetricsCache = <T,>(key: string): T | null => {
  return (cashFlowMetricsCache.get(key) as T | undefined) ?? null
}

export const setCashFlowMetricsCache = <T,>(key: string, value: T) => {
  cashFlowMetricsCache.set(key, value)
}

export const deleteCashFlowMetricsCache = (key: string) => {
  cashFlowMetricsCache.delete(key)
}
